// Binary search to find the start index of the node that contains position.
// Indices is an array of the starting index of each text node in the document.
// e.g. indices = [0, 5, 10, 15], position = 7
// findStartNodeIndex(indices, position) => 1
export const findStartNodeIndex = (
  indices: number[],
  position: number
): number => {
  let left = 0;
  let right = indices.length - 1;

  while (left <= right) {
    const mid = Math.floor((left + right) / 2);
    if (
      indices[mid] <= position &&
      (mid === indices.length - 1 || indices[mid + 1] > position)
    ) {
      return mid;
    }
    if (indices[mid] > position) {
      right = mid - 1;
    } else {
      left = mid + 1;
    }
  }

  return -1;
};

// Once we have the start index, the end index is probably only a few nodes
// away. We can start searching from the start index.
// e.g. indices = [0, 5, 10, 15], startIndex = 1, position = 11
// findEndNodeIndex(indices, startIndex, position) => 2
export const findEndNodeIndex = (
  indices: number[],
  startIndex: number,
  position: number
) => {
  for (let i = startIndex; i < indices.length; i++) {
    if (
      indices[i] <= position &&
      (i === indices.length - 1 || indices[i + 1] >= position)
    ) {
      return i;
    }
  }

  return -1;
};
